import { Instant, ZoneId } from "@js-joda/core";
import { I } from "services/lang/LanguageService";
import {
  DayTypes,
  MonthDisplayType,
  MonthTypes,
  Position,
  YearTypes,
} from "./CurentDateDisplayTypes";
import { monthsArray, monthsArrayShort } from "../charts/utils";

const getCurrentDate = (year: YearTypes, month: MonthTypes, day: DayTypes) => {
  const localDate = Instant.now().atZone(ZoneId.systemDefault()).toLocalDate();
  const currentYear = localDate.year();
  let monthNumber = localDate.monthValue();
  const currentDay = localDate.dayOfMonth();

  const parts: { value: string; position: Position }[] = [];

  if (year?.show ?? true) {
    parts.push({
      value: `${currentYear}${year?.suffix ? ` ${I(year.suffix)}` : ""}`,
      position: year?.position ?? Position.START,
    });
  }

  if (month?.show ?? true) {
    if (month?.showFinishedMonth) {
      monthNumber -= 1;
      if (monthNumber < 1) {
        monthNumber = 12;
      }
    }

    let monthStr: string;
    switch (month?.displayType) {
      case MonthDisplayType.STRING_LONG:
        monthStr = monthsArray[monthNumber - 1];
        break;
      case MonthDisplayType.STRING_SHORT:
        monthStr = monthsArrayShort[monthNumber - 1];
        break;
      default:
        monthStr = monthNumber.toString();
    }
    parts.push({
      value: monthStr,
      position: month?.position ?? Position.MIDDLE,
    });
  }

  if (day?.show ?? true) {
    parts.push({
      value: `${currentDay}`,
      position: day?.position ?? Position.END,
    });
  }

  const ordered = [Position.START, Position.MIDDLE, Position.END].flatMap(pos =>
    parts.filter(p => p.position === pos)
  );

  return ordered.map(p => p.value).join(" ");
};

export default getCurrentDate;
